import { useState, useRef } from "react";
import { CalendarClock, Plus, Trash2 } from "lucide-react";

const nid = () => Math.random().toString(36).slice(2, 10);

// Flere deadlines / gentagelseskontrol på et Fund eller en Handling.
// Lokal state + debounced gem, så skrivning er øjeblikkelig (ingen fokus-tab / lag).
export function MilestonesCard({ milestones, onSave, disabled, testid = "milestones", badge = null }) {
  const [list, setList] = useState(milestones || []);
  const timer = useRef();

  const push = (next, immediate) => {
    setList(next);
    clearTimeout(timer.current);
    if (immediate) onSave(next);
    else timer.current = setTimeout(() => onSave(next), 600);
  };
  const add = () => push([...list, { id: nid(), label: "", deadline: "", done: false }], true);
  const upd = (id, patch, immediate) => push(list.map((m) => (m.id === id ? { ...m, ...patch } : m)), immediate);
  const del = (id) => push(list.filter((m) => m.id !== id), true);
  const done = list.filter((m) => m.done).length;

  return (
    <div className="bg-white rounded-2xl border border-[#EBE8E3] p-5" data-testid={`${testid}-card`}>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-semibold text-[#1A1919] flex items-center gap-2">{badge && <span className="h-7 w-7 rounded-full bg-[#F1EAE4] text-[#A83232] text-xs font-bold flex items-center justify-center mr-0.5">{badge}</span>}<CalendarClock className="h-4 w-4 text-[#806B61]" /> Deadlines / milepæle{list.length > 0 && <span className="text-xs font-normal text-stone-400">({done}/{list.length} udført)</span>}</h2>
        <button type="button" onClick={add} disabled={disabled} className="text-sm text-[#806B61] flex items-center gap-1.5 hover:text-[#5f574e]" data-testid={`${testid}-add`}><Plus className="h-4 w-4" /> Tilføj deadline</button>
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-stone-400">Ingen ekstra deadlines. Brug fx til gentagelseskontrol (slutkontrol måned 1, måned 2 …).</p>
      ) : (
        <div className="space-y-2">
          {list.map((m) => (
            <div key={m.id} className={`flex items-center gap-2.5 rounded-xl border px-3 py-2 ${m.done ? "border-[#D3D8C6] bg-[#F6F8F1]" : "border-[#EBE8E3]"}`} data-testid={`${testid}-item-${m.id}`}>
              <input type="checkbox" checked={!!m.done} disabled={disabled} onChange={(e) => upd(m.id, { done: e.target.checked }, true)} className="h-4 w-4 accent-[#5f6b4a] shrink-0" data-testid={`${testid}-check-${m.id}`} />
              <input value={m.label || ""} disabled={disabled} onChange={(e) => upd(m.id, { label: e.target.value })} placeholder="Beskrivelse (fx Slutkontrol – måned 1)" className={`flex-1 h-9 px-2.5 rounded-lg border border-[#EBE8E3] bg-white text-sm ${m.done ? "line-through text-stone-400" : ""}`} data-testid={`${testid}-label-${m.id}`} />
              <input type="date" value={m.deadline || ""} disabled={disabled} onChange={(e) => upd(m.id, { deadline: e.target.value }, true)} className="h-9 px-2 rounded-lg border border-[#EBE8E3] bg-white text-sm" data-testid={`${testid}-date-${m.id}`} />
              <button type="button" onClick={() => del(m.id)} disabled={disabled} className="text-stone-400 hover:text-[#A83232] shrink-0" title="Fjern"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
